import autobind from 'core-decorators/lib/autobind';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { isInFullScreen } from 'shared/selectors/player';


@connect(state => ({
  isInFullScreen: isInFullScreen(state),
}))
export default class WindowSize extends React.Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    isInFullScreen: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,
      height: window.innerHeight,
    };

    this.updateWidgetSizeInterval = null;
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSize);

    if (this.state.width) {
      return;
    }
    // For cases, when editor don`t show iFrame from not selected page at mobile mode
    this.updateWidgetSizeInterval = setInterval(this.updateSize, 200);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateSize);

    if (this.updateWidgetSizeInterval) {
      clearInterval(this.updateWidgetSizeInterval);
    }
  }

  @autobind
  updateSize() {
    // Need to wait for setting isInFullScreen to store
    // TODO use isFullScreenRequested and remove timeout
    setTimeout(() => {
      if (!window.innerWidth || this.props.isInFullScreen) {
        return;
      }

      if (this.updateWidgetSizeInterval) {
        clearInterval(this.updateWidgetSizeInterval);
      }

      this.setState({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    });
  }

  render() {
    return React.cloneElement(this.props.children, {
      windowSize: this.state,
    });
  }
}



// WEBPACK FOOTER //
// ./src/shared/containers/window-size.js